import React from "react";
import { HeaderBox } from "./style";
import OrderTabs from "../tabs/TableTabs";

const OrderTableHeader = ({
  tabLabels,
  selectedTab,
  setSelectedTab,
  responsiveMode = false,
}) => {
  return (
    <HeaderBox responsiveMode={responsiveMode}>
      <OrderTabs
        tabLabels={tabLabels}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        responsiveMode={responsiveMode}
      />
      {/* <StyledButtonBox responsiveMode={responsiveMode}>
        <StyledButtonSend variant="outlined" startIcon={<CiFilter />}>
          Filter
        </StyledButtonSend>
        <StyledButtonSend
          variant="outlined"
          startIcon={<CiExport />}
          color="warning"
        >
          Export
        </StyledButtonSend>
      </StyledButtonBox> */}
    </HeaderBox>
  );
};

export default OrderTableHeader;
